import { render, staticRenderFns } from "./ComplaintDetailEvent.vue?vue&type=template&id=d053d4c8&scoped=true"
import script from "./ComplaintDetailEvent.vue?vue&type=script&lang=js"
export * from "./ComplaintDetailEvent.vue?vue&type=script&lang=js"
import style0 from "./ComplaintDetailEvent.vue?vue&type=style&index=0&id=d053d4c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d053d4c8",
  null
  
)

export default component.exports